import React from 'react';

import {
  ScreenAllFilters,
  ScreenFilters,
  ScreenFiltersApply,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { makeStyles, Grid } from '@gogame/components';
import {
  Screen,
  withScreen,
  Route,
  Routes,
  Navigate,
  useParams,
  useScreenGo,
} from '@gogame/screens';

import AllFilters from 'scenes/Gallery/ConversionPages/Filters/AllFilters';
import PrimaryFilters from 'scenes/Gallery/ConversionPages/Filters/PrimaryFilters';
import {
  GroupsDataTable,
  ConversionGroupsDataTableProvider,
} from 'scenes/Gallery/ConversionPages/ConversionGroups/ConversionGroupsDataTable';
import {
  ConversionPagesDataTable,
  ConversionPagesDataTableProvider,
} from 'scenes/Gallery/ConversionPages/ConversionPages/ConversionPagesDataTable';
import {
  TAB_GROUPS,
  TAB_PAGES,
} from 'scenes/Gallery/ConversionPages/constants';
import {
  EMPTY_FILTERS,
  mapStateToPreset,
} from 'scenes/Gallery/ConversionPages/schemas';
import screenReducer from 'scenes/Gallery/ConversionPages/screenReducer';

import Tabs from './components/Tabs';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    position: 'relative',
  },
  paper: {
    border: '1px solid rgba(0,0,0,0.12)',
  },
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
}));

const ConversionPagesScreen = withScreen({
  name: 'conversion-pages',
  reducer: screenReducer,
})(() => {
  const classes = useStyles();
  const { '*': tab } = useParams();
  const go = useScreenGo();
  const handleTabChange = (_e, newActiveTabId) => {
    go(`../${newActiveTabId}`);
  };

  const tabs = <Tabs value={tab} onChange={handleTabChange} />;

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <ScreenFiltersApply />
        </ScreenFilters>
        <div style={{ position: 'relative', display: 'flex', flexGrow: 1 }}>
          <ConversionGroupsDataTableProvider>
            <ConversionPagesDataTableProvider>
              <Grid item className={classes.container}>
                <Routes>
                  <Route
                    path={`${TAB_GROUPS}/*`}
                    element={<GroupsDataTable tabs={tabs} />}
                  />
                  <Route
                    path={`${TAB_PAGES}/*`}
                    element={<ConversionPagesDataTable tabs={tabs} />}
                  />
                  <Route
                    path={'*'}
                    element={
                      <Navigate
                        to={`${TAB_GROUPS}${window.location.search}`}
                        replace={true}
                      />
                    }
                  />
                </Routes>
              </Grid>
            </ConversionPagesDataTableProvider>
          </ConversionGroupsDataTableProvider>
        </div>
      </Screen.Body>
    </React.Fragment>
  );
});

export default ConversionPagesScreen;
